import { PackageFilter } from '../../packages/package-filter'

export enum StorageOperationRequestType {
  CHECK_IN = 'CHECK_IN',

  RETRACT = 'RETRACT',

  CHECK_OUT = 'CHECK_OUT',

  MOVE = 'MOVE',
}

export class StorageOperationRequest {
  public static checkIn(checkIn: CheckIn): StorageOperationRequest {
    return new StorageOperationRequest(
      StorageOperationRequestType.CHECK_IN,
      checkIn,
      undefined,
      undefined,
      undefined
    )
  }

  public static retract(retraction: Retraction): StorageOperationRequest {
    return new StorageOperationRequest(
      StorageOperationRequestType.RETRACT,
      undefined,
      retraction,
      undefined,
      undefined
    )
  }

  public static checkOut(checkOut: CheckOut): StorageOperationRequest {
    return new StorageOperationRequest(
      StorageOperationRequestType.CHECK_OUT,
      undefined,
      undefined,
      checkOut,
      undefined
    )
  }

  constructor(
    public type: StorageOperationRequestType,
    public checkIn?: CheckIn,
    public retraction?: Retraction,
    public checkOut?: CheckOut,
    public movement?: Movement
  ) {}
}

export class CheckIn {
  constructor(
    public mode: CheckInMode,
    public workOrderId: string,
    public packages: string[],
    public baseLocation: string,
    public targetLocation?: string
  ) {}
}

export class Retraction {
  constructor(public packages: string[]) {}
}

export class CheckOut {
  constructor(public packages: string[]) {}
}

export class Movement {
  constructor(
    public packageFilter: PackageFilter,
    public targetLocation: string
  ) {}
}

export enum CheckInMode {
  PREVIEW = 'PREVIEW',

  CONFIRMING = 'CONFIRMING',
}
